export const CONTACT = {
  phoneMain: "+39 06 69 42 20 20",
  phoneMainHref: "tel:+390669422020",
  phoneMobile: "+39 351 665 9998",
  phoneMobileHref: "tel:+393516659998",
  whatsapp: "https://wa.me/393516659998",
  emails: ["info@gigaprint.it", "segreteria@gigaprint.it"],
  vat: "14289151004",
  instagram: "https://www.instagram.com/nuovagigaprint/",
  facebook: "#",
  linkedin: "#",
};

export const SEDI = [
  {
    city: "Roma",
    address: "Via Giovanni Neper, 14",
    cap: "00166 Roma",
    map: "https://www.google.com/maps?q=Via+Giovanni+Neper+14,+00166+Roma&output=embed",
  },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Chi Siamo", to: "/chi-siamo" },
  { label: "Prodotti", to: "/prodotti" },
  { label: "Stampe", to: "/stampe" },
  { label: "Allestimenti", to: "/allestimenti" },
  { label: "Marketing", to: "/marketing" },
  { label: "Press", to: "/press" },
  { label: "Contatti", to: "/contatti" },
];

export const TRUST = [
  { icon: "Factory", title: "Produzione interna", text: "La maggior parte degli articoli nasce nel nostro stabilimento." },
  { icon: "Cpu", title: "Macchinari di ultima generazione", text: "Stampa e taglio con tecnologie avanzate." },
  { icon: "ScanSearch", title: "Controllo qualità", text: "Standard elevati in ogni fase della lavorazione." },
  { icon: "Timer", title: "Tempi di consegna rispettati", text: "Le date concordate sono un impegno, non una stima." },
];

export const SERVICES = [
  { n: "01", title: "Servizi Stampa", text: "Stampa su ogni tipologia di formato e supporto, dal biglietto al grande formato.", img: "/img/hero-printer.webp", alt: "Plotter di stampa grande formato in funzione con banner colorato", to: "/stampe" },
  { n: "02", title: "Allestimenti", text: "Sistemi espositivi su misura per eventi, punti vendita e spazi aziendali.", img: "/img/Allestimenti.webp", alt: "Allestimento evento all'aperto con bandiere e desk brandizzati Nuova Giga Print", to: "/allestimenti" },
  { n: "03", title: "Creatività", text: "Consulenza di Creatività & Graphic Design per la stampa e il digitale.", img: "/img/creativita-gigaprint.webp", alt: "Immagine coordinata Giga Print: pieghevole, biglietti da visita e carta intestata con il nuovo logo", to: "/creativita" },
  { n: "04", title: "Gadget personalizzati", text: "Penne, cappellini, chiavette e bandiere con il tuo logo aziendale.", img: "/img/gadget-gigaprint.webp", alt: "Gadget personalizzati Giga Print: penna, cappellino, chiavetta USB e bandierina con logo", to: "/gadget" },
];

export const SOLUTIONS = [
  {
    eyebrow: "Tecniche di stampa",
    title: "Ogni tecnica, su qualunque supporto e formato.",
    img: "/img/printer-cut.webp",
    alt: "Macchinario di stampa digitale con foglio in lavorazione",
    points: ["Stampa digitale", "Stampa offset", "Serigrafia", "Tampografia", "Grande formato e pellicole adesive"],
    to: "/stampe",
  },
  {
    eyebrow: "Materiali e sistemi espositivi",
    title: "Progettati su misura, con materiali moderni.",
    img: "/img/letter-studio.webp",
    alt: "Lettering tridimensionale applicato su parete in doghe di legno",
    points: ["PVC", "Alluminio nelle sue varie finiture", "Legno", "Plexiglass", "Prodotti realizzati nel nostro stabilimento e allestiti dai nostri collaboratori"],
    to: "/prodotti",
  },
  {
    eyebrow: "Creatività & Graphic Design",
    title: "Un'idea chiara prima di andare in stampa.",
    img: "/img/design-desk.webp",
    alt: "Postazione di graphic design con monitor e tavolo in legno",
    points: ["Consulenza creativa per la stampa", "Grafica per applicazioni digitali", "Studio dell'allestimento più adatto a ogni progetto"],
    to: "/creativita",
  },
];

export const DIGITAL = [
  { icon: "MonitorSmartphone", title: "Creazione siti web", text: "Siti chiari e veloci per presentare l'azienda e ricevere contatti." },
  { icon: "MapPin", title: "Gestione Google My Business", text: "Profili aggiornati per farti trovare da chi cerca nella tua zona." },
  { icon: "ChartNoAxesCombined", title: "Analisi dei dati", text: "Numeri letti e spiegati per decidere dove investire." },
];

export const STATS = [
  { value: 659, label: "Clienti soddisfatti" },
  { value: 726, label: "Progetti realizzati" },
  { value: 832, label: "Allestimenti" },
  { value: 12674, label: "Stampe realizzate" },
];

export const GALLERY_FILTERS = ["Tutti", "Wrapping", "Vetrofanie", "Lettering 3D", "Allestimenti", "Stampa & Gadget"];

export const GALLERY = [
  { cat: "Wrapping", img: "/img/wrap-orange.webp", title: "Car wrapping", alt: "Applicazione di pellicola arancione sulla carrozzeria di un'auto", h: "tall" },
  { cat: "Allestimenti", img: "/img/Allestimenti.webp", title: "Allestimento evento outdoor", alt: "Desk e bandiere vela brandizzati per evento all'aperto", h: "base" },
  { cat: "Lettering 3D", img: "/img/letter-noon.webp", title: "Lettering 3D retroilluminato", alt: "Lettere tridimensionali illuminate su parete scura", h: "tall" },
  { cat: "Vetrofanie", img: "/img/window.webp", title: "Vetrofanie per vetrine", alt: "Vetrina di negozio con grafiche adesive bianche", h: "base" },
  { cat: "Stampa & Gadget", img: "/img/gadget-gigaprint.webp", title: "Gadget brandizzati", alt: "Set di gadget aziendali personalizzati con logo", h: "base" },
  { cat: "Wrapping", img: "/img/wrap-blue.webp", title: "Posa pellicole", alt: "Operatore con guanti che applica pellicola su carrozzeria blu", h: "base" },
  { cat: "Allestimenti", img: "/img/stage.webp", title: "Allestimenti per palchi", alt: "Palco con schermo e luci per evento aziendale", h: "base" },
  { cat: "Lettering 3D", img: "/img/letter-studio.webp", title: "Insegna in rilievo", alt: "Lettere in rilievo su parete in legno", h: "tall" },
  { cat: "Stampa & Gadget", img: "/img/creativita-gigaprint.webp", title: "Pieghevoli e brochure", alt: "Pieghevole e biglietti da visita stampati con logo Giga Print", h: "base" },
  { cat: "Wrapping", img: "/img/wrap-detail.webp", title: "Wrapping di dettaglio", alt: "Rifinitura di pellicola su faro di un'auto", h: "base" },
  { cat: "Stampa & Gadget", img: "/img/printer-roll.webp", title: "Stampa grande formato", alt: "Plotter grande formato in laboratorio", h: "base" },
  { cat: "Allestimenti", img: "/img/event-tables.webp", title: "Eventi all'aperto", alt: "Area eventi all'aperto con tavoli e strutture", h: "base" },
];

export const CLIENTS = [
  "Porsche", "CONI", "BMW · MINI · Rolls-Royce", "Suzuki", "Ducati", "Deutsche Bank", "Eni", "Qatar", "StanleyBet",
  "Arcese", "Codere", "Wella", "Laura Biagiotti", "ALD Automotive", "Gran Caffè Santos", "Tor Vergata",
  "Città di Roma", "FIT", "FISE", "FISG", "Banco Popolare", "Fatebenefratelli", "CT Eur", "Driver",
];

export const PRESS = {
  outlet: "RomaToday",
  date: "30/04/2020",
  title: "Plexiglass anti-Covid: come ci siamo rinnovati durante il lockdown",
  text: "Durante il lockdown abbiamo trovato soluzioni veloci in plexiglass per permettere alle aziende di lavorare in sicurezza. L'intervista racconta come.",
  url: "https://www.romatoday.it/attualita/video-plexiglass-anti-covid-roma.html",
};

export const QUOTE_SERVICES = ["Servizi Stampa", "Allestimenti", "Creatività & Graphic Design", "Gadget personalizzati", "Digital Marketing", "Altro"];
